import { faCircleCheck, faEye, faPen, faTrash, faWarning } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, CircularProgress, IconButton, Menu, MenuItem, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow } from "@mui/material";
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import TablePaginationActions from '../../../base-components/TablePaginationActions';
import CustomModal from '../../../base-components/CustomModal';
import Popup from '../../../base-components/Popup';
import { facilitySchema } from '../../../schemas';
import Tooltip from '@mui/material/Tooltip';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { getSessionUser, hasPermission, isDynamicStaffRole } from '../../../utils/roleAccess';
import { PageHeader } from "../../../ui";

const BASE_URL = process.env.REACT_APP_BASE_URL;
function Facilities() {
    const navigate = useNavigate()
    const [facilities , setFacilities] = useState([])
    const [facility , setFacility] = useState({})
    const [locations , setLocations] = useState([])
    const [facilityToDelete , setFacilityToDelete] = useState('')
    const [facilityToUpdate , setFacilityToUpdate] = useState('')
    const [isAddModalOpen , setIsAddModalOpen] = useState(false)
    const [isViewModalOpen , setIsViewModalOpen] = useState(false)
    const [isDeleteModalOpen , setIsDeleteModalOpen] = useState(false)
    const [isUpdateModalOpen , setIsUpdateModalOpen] = useState(false)
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page , setPage ] = useState(0)
    const [isSuccessAlert , setIsSuccessAlert] = useState(false)
    const [isFaliureAlert , setIsFailureAlert] = useState(false)
    const [successMessage , setSuccessMessage] = useState('')
    const [failureMessage , setFailureMessage] = useState('')
    const [isPopupOpen , setIsPopupOpen] = useState(false)
    const [role , setRole] = useState('')
    const [location_id , setLocationId] = useState('')
    const [company_id , setCompanyID] = useState('')
    const [loading , setLoading] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null);
    const openAnchor = Boolean(anchorEl);
    const [selectedFacility, setSelectedFacility] = useState(null);
    const [buttonLoading, setButtonLoading] = useState(false);

    const handleClickAnchor = (event, facilityId) => {
      setAnchorEl(event.currentTarget);
      setSelectedFacility(facilityId);
    };
    const handleCloseAnchor = () => {
      setAnchorEl(null);
      setSelectedFacility(null);
    };

    useEffect(()=> {
        const sessionStr = sessionStorage.getItem('user-info');
        if(sessionStr){
          const session = JSON.parse(sessionStr);
          setRole(session.user.role)
          setCompanyID(session.user.company_id)
          setLocationId(session.user.location_id)
        }
         else {
          navigate('/login');
        }
  },[])

    useEffect(()=> {
        if(role) {
            setLoading(true)
            getFacilities()
            getLocations()
            setTimeout(()=> {
                setLoading(false)
            },1000)
        }
    },[role])

    async function getFacilities () {

        if(!role) return;
        let endpoint = '';
        console.log(role);
        if (role === 'SuperAdmin') {
            endpoint = 'facility/getPackageFacilities';
        } else if (role === 'Admin') {
            endpoint = `facility/getPackageFacilityByCompanyId/${company_id}`;
        } else if (role === 'ClubAdmin') {
            endpoint = `facility/getPackageFacilityByLocationId/${location_id}`;
        } else if (isDynamicStaffRole(role)) {
            endpoint = `facility/getPackageFacilityByLocationId/${location_id}`;
        }
        await fetch(BASE_URL + endpoint)
        .then((response) => response.json())
        .then((data) => {
            setFacilities(data.packageFacilities)
            
        })
        .catch((error) => console.log(error));
    }

    async function getLocations () {
        if(!role) return;

        let endpoint = '';
        console.log(role);
        if (role === 'SuperAdmin') {
            endpoint = 'locations/getLocations';
        } else if (role === 'Admin') {
            endpoint = `locations/getLocationsByCompanyID/${company_id}`;
        }
        
        await fetch(BASE_URL + endpoint)
            .then((response) => response.json())
            .then((data) => {
                setLocations(data.locations)
            })
            .catch((error) => {
                console.log(error)
            } );
    }

    async function getFacilityByID (id) {
        await fetch(BASE_URL + `facility/getPackageFacilityById/${id}`)
        .then((response) => response.json())
        .then((data) => {
            setFacility(data.packageFacility)
            setValues(data.packageFacility);
          
        })
        .catch((error) => console.log(error));
    }
    
    const handleAddFacility = async (values, actions) => {
            setButtonLoading(true);
            console.log("values:--", values);
           
            const requestOptions = {
                
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values),
            };

            try {
            

                const response = await fetch(BASE_URL + `facility/createPackageFacility`, requestOptions);
               

                console.log('Response status:', response.status);
                if (!response.ok) {
                    const data = await response.json()
                    console.error('Response not ok:' , data);
                    setIsFailureAlert(true)
                    setFailureMessage(data.message)
                    setIsPopupOpen(true)
                    setTimeout(() => {
                        setIsPopupOpen(false)
                    } , 5000);
                } else {
                    const responseData = await response.json();
                    console.log('Response data:', responseData);
                    setIsAddModalOpen(false)
                    actions.resetForm()
                    getFacilities()
                    setIsSuccessAlert(true)
                    setSuccessMessage('Facility added Successfully')
                    setIsPopupOpen(true)
                    setTimeout(() => {
                        setIsPopupOpen(false)
                    } , 5000)
                }
            } catch (error) {
                console.error('Caught error:', error);
                setIsFailureAlert(true) 
                setFailureMessage('Failed to add Facility')
                setIsPopupOpen(true)
                setTimeout(() => {
                    setIsPopupOpen(false)
                } , 5000)
            } finally {
                setButtonLoading(false);
                // setLoading(false);
            }
    
    }

    const handleUpdateFacility = async (values, actions) => {
        setButtonLoading(true);
        values.company_id = company_id;
        const requestOptions = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(values),
        };

        try {
            const response = await fetch(BASE_URL + `facility/updatePackageFacility/${facilityToUpdate}`, requestOptions);

            console.log('Response status:', response.status);
            if (!response.ok) {
                console.error('Response not ok:', response);
                setIsFailureAlert(true)
                setFailureMessage('Failed to Update Facility')
                setIsPopupOpen(true)
                setTimeout(() => {
                    setIsPopupOpen(false)
                }, 5000)
            } else {
                const responseData = await response.json();
                console.log('Response data:', responseData);
                actions.resetForm()
                setIsUpdateModalOpen(false)
                getFacilities()
                setIsSuccessAlert(true)
                setSuccessMessage('Facility Updated Successfully')
                setIsPopupOpen(true)
                setTimeout(() => {
                    setIsPopupOpen(false)
                }, 5000)
            }
        } catch (error) {
            console.error('Caught error:', error);
            setIsFailureAlert(true)
            setFailureMessage('Failed to Update Facility')
            setIsPopupOpen(true)
            setTimeout(() => {
                setIsPopupOpen(false)
            }, 5000)
        } finally {
            setButtonLoading(false);
            // setLoading(false);
        }

}

    async function deleteFacility () {
        setButtonLoading(true);
        const requestOptions = {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            },
        };
        await fetch(BASE_URL + `facility/deletePackageFacility/${facilityToDelete}` , requestOptions)
        .then((response) => response.json())
        .then((data) => {
            getFacilities()
            setIsDeleteModalOpen(false)
            setIsSuccessAlert(true)
            setSuccessMessage('Facility deleted Successfully')
            setIsPopupOpen(true)
            setTimeout(() => {
                setIsPopupOpen(false)
            }, 5000)
        })
        .catch((error) => {
            console.log(error)
            setIsFailureAlert(true)
            setFailureMessage('Failed to delete Facility')
            setIsPopupOpen(true)
            setTimeout(() => {
                setIsPopupOpen(false)
            }, 5000)
        }).finally(() => {
            setButtonLoading(false);
        });
    }


    function toggleAddModal() {
        setIsAddModalOpen(!isAddModalOpen)
        resetForm()
    }
    function toggleViewModal() {
        setIsViewModalOpen(!isViewModalOpen)
        resetForm()
    }

    function toggleUpdateModal() {
        setIsUpdateModalOpen(!isUpdateModalOpen)
        resetForm()
    }
    function toggleDeleteModal() {
        setIsDeleteModalOpen(!isDeleteModalOpen)
    }

    function showAddModal(id) {
        setIsAddModalOpen(true);
    }
    function showViewModal(id) {
        getFacilityByID(id);
        setIsViewModalOpen(true);
    }
    function showUpdateModal(id) {

        getFacilityByID(id);
        setFacilityToUpdate(id);
        setIsUpdateModalOpen(true);
    }
    function showDeleteModal(id) {
        setFacilityToDelete(id);
        setIsDeleteModalOpen(true);
    }
    

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
      };

        const {values , touched , errors , handleBlur , handleChange , handleSubmit , setValues , resetForm , setFieldValue} = useFormik({
            enableReinitialize: true, 
            initialValues: {
                name: '',
                description: '',
                fee: '',
                location_id: role === "ClubAdmin" ? location_id :'',
                company_id: company_id,
            },
            validationSchema: facilitySchema,
            onSubmit: (values, actions) => {
                if(isAddModalOpen){
                    handleAddFacility(values, actions); // Call the external function
                } else if(isUpdateModalOpen) {
                    handleUpdateFacility(values, actions);
                }
            },
        })
  return (
    <>
        <div className="m-5">
          <PageHeader
            title="Facilities"
            actions={
              hasPermission(getSessionUser(), 'facilities:create') ? (
                  <button className='gx-cta ' onClick={showAddModal}>Add Facility</button>
              ) : null
            }
          />
        </div>
        
        {
          loading ? (
             
               <div className="flex justify-center items-center mt-20 relative">
                 {/* SVG Gradient Definition */}
                 <svg width="0" height="0">
                   <defs>
                     <linearGradient id="gradientColors" x1="1" y1="0" x2="0" y2="1">
                       <stop offset="0%" stopColor="#D71920" />
                       <stop offset="100%" stopColor="#F7931E" />
                     </linearGradient>
                   </defs>
                 </svg>
         
                 {/* Circular Progress with Gradient Stroke */}
                 <CircularProgress
                   thickness={4}
                   size={35}
                   sx={{
                     'svg circle': {
                       stroke: 'url(#gradientColors)', // Apply gradient stroke
                     },
                   }}
                 />
               </div>
             
           ) : (
                facilities && facilities.length !== 0 ? (     
                <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx m-5 animate-fadeIn overflow-y-auto  overflow-x-auto">
                    <Table>
                      <TableHead>
                          <TableRow >
                              <TableCell>Serial</TableCell>
                              <TableCell>Name</TableCell>
                              <TableCell>Description</TableCell>
                              <TableCell>Fee</TableCell>
                              <TableCell>Actions</TableCell>
                          </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          facilities.map((facility , index) => (
                            <TableRow hover key={index}>
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{facility.name}</TableCell>
                              <TableCell>{facility.description}</TableCell>
                              <TableCell>{facility.fee}</TableCell>
                              <TableCell>
                                <Tooltip title="Actions">
                                  <IconButton onClick={(event) => handleClickAnchor(event, facility._id)}>
                                    <MoreVertIcon />
                                  </IconButton>
                                </Tooltip>
                                <Menu anchorEl={anchorEl} open={openAnchor} onClose={handleCloseAnchor}>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseAnchor();
                                      showViewModal(selectedFacility);
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faEye} className='mr-2'/> View 
                                  </MenuItem>
                                  {hasPermission(getSessionUser(), 'facilities:update') && (
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseAnchor();
                                      showUpdateModal(selectedFacility);
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faPen} className='mr-2' /> Update
                                  </MenuItem>
                                  )}
                                  {hasPermission(getSessionUser(), 'facilities:delete') && (
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseAnchor();
                                      showDeleteModal(selectedFacility);
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faTrash} className='mr-2'/> Delete
                                  </MenuItem>
                                  )}
                                </Menu>
                              </TableCell>
                            </TableRow>
                          ))
                        }
                      </TableBody>
                      <TableFooter>
                          <TableRow>
                          <TablePagination
                              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                              colSpan={12}
                              count= {facilities.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              slotProps={{
                                  select: {
                                  inputProps: {
                                      'aria-label': 'rows per page',
                                  },
                                  native: true,
                                  },
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                              />
                          </TableRow>
                      </TableFooter>
                  </Table>
                </Box>
                ) : (
                  <div className='bg-gx-border w-ful p-3 mt-10 rounded-lg m-10'>
                    <h3 className='text-xl font-bold text-center text-gx-ink-soft'>No Records Found</h3>
                  </div>
                )
          )
            
          }

<CustomModal 
  isModal={isAddModalOpen || isUpdateModalOpen} 
  handleModal={() => {
    if (isAddModalOpen) {
      toggleAddModal();
    } else if (isUpdateModalOpen) {
      toggleUpdateModal();
    }
  }} 
  size='xl'
>
  <h1 className='font-bold text-3xl text-gx-ink-soft p-5 border-b mx-2'>
    {isAddModalOpen ? 'Add Facility' : 'Update Facility'}
  </h1>

  <form onSubmit={handleSubmit} className='text-gx-ink-soft m-5' autoComplete='off'>
    <div>
      <input type='hidden' value={values.company_id} />
    </div>

    {/* Name and Description Fields in one row */}
    <div className='flex flex-col sm:flex-row sm:justify-between gap-5 mt-5'>
      {/* Name Field */}
      <div className='w-full sm:w-1/2'>
        <label>Name <span className='text-red-600'>*</span></label>
        <input 
          type='text' 
          name='name' 
          placeholder='Enter Name' 
          value={values.name}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${errors.name && touched.name ? 'border-red-600' : ''}`}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.name && errors.name && <p className='text-red-500 pl-2 italic'>{errors.name}</p>}
      </div>

      {/* Description Field */}
      <div className='w-full sm:w-1/2'>
        <label>Description:</label>
        <input 
          type='text' 
          name='description' 
          placeholder='Enter Description' 
          value={values.description}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${errors.description && touched.description ? 'border-red-600' : ''}`}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.description && errors.description && <p className='text-red-500 pl-2 italic'>{errors.description}</p>}
      </div>
    </div>

    {/* Fee Field */}
    <div className='flex flex-col sm:flex-row sm:justify-between gap-5 mt-5'>
      <div className='w-full sm:w-1/2'>
        <label>Fee <span className='text-red-600'>*</span></label>
        <input 
          type='number' 
          name='fee' 
          placeholder='Enter Fee' 
          value={values.fee}
          className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${errors.fee && touched.fee ? 'border-red-600' : ''}`}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.fee && errors.fee && <p className='text-red-500 pl-2 italic'>{errors.fee}</p>}
      </div>

      {/* Location Field (only for SuperAdmin or Admin) */}
      {role === "SuperAdmin" || role === "Admin" && (
        <div className='w-full sm:w-1/2'>
          <label>Location <span className='text-red-600'>*</span></label>
          <select 
            name='location_id' 
            placeholder='Select Location'
            value={values.location_id}
            className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${errors.location_id && touched.location_id ? 'border-red-600' : ''}`}
            onChange={handleChange}
            onBlur={handleBlur}
          >
            <option value="">Locations</option>
            {locations?.map((location, index) => (
              <option key={index} value={location._id}>{location.name}</option>
            ))}
          </select>
          {touched.location_id && errors.location_id && <p className='text-red-500 pl-2 italic'>{errors.location_id}</p>}
        </div>
      )}
    </div>

    {/* Company Field (only for SuperAdmin) */}
    {role === "SuperAdmin" && (
      <div className='flex flex-col sm:flex-row sm:justify-between gap-5 mt-5'>
        <div className='w-full sm:w-1/2'>
          <label>Company:</label>
          <select 
            name='company_id' 
            placeholder='Select Company'
            value={values.company_id}
            className={`border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 ${errors.company_id && touched.company_id ? 'border-red-600' : ''}`}
            onChange={handleChange}
            onBlur={handleBlur}
          >
            <option>Select Company</option>
            {/* Assuming company options will be dynamically added */}
          </select>
          {touched.company_id && errors.company_id && <p className='text-red-500 pl-2 italic'>{errors.company_id}</p>}
        </div>
      </div>
    )}

    {/* Submit Button */}
    <div className="flex justify-center items-center pt-3 mt-3 border-t">
      <button type='submit' className={`flex bg-blue-600 p-2 px-10 rounded-lg text-white font-medium hover:bg-blue-700 ${buttonLoading ? "cursor-not-allowed bg-gray-400" : ""}`} disabled={buttonLoading}>
        {buttonLoading ? "Submitting..." : "Submit"}
        {buttonLoading && (
          <CircularProgress size={20} className="ml-2 mt-1" sx={{ color:'#fff' }} />
        )}
      </button>
    </div>
  </form>
</CustomModal>

      
<CustomModal isModal={isViewModalOpen} handleModal={toggleViewModal} size="2xl">
  
    <div className="p-3 sm:p-5">
      <Tooltip title="" placement="bottom">
        <div className="px-2 sm:px-5">
          <h1 className="font-bold text-xl sm:text-2xl md:text-3xl text-gx-ink-soft pb-3 sm:pb-5 border-b">
            View Facility
          </h1>
        </div>
        <div className="mx-1 sm:mx-2 mt-3 sm:mt-5 overflow-x-auto">
          <Box>
            <Table className="min-w-full">
              <TableBody>
                <TableRow>
                  <TableCell className="text-xs sm:text-sm md:text-base px-2 py-1 sm:px-4 sm:py-2">Name</TableCell>
                  <TableCell className="text-xs sm:text-sm md:text-base px-2 py-1 sm:px-4 sm:py-2 break-words">{facility.name}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="text-xs sm:text-sm md:text-base px-2 py-1 sm:px-4 sm:py-2">Description</TableCell>
                  <TableCell className="text-xs sm:text-sm md:text-base px-2 py-1 sm:px-4 sm:py-2 break-words">{facility.description}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="text-xs sm:text-sm md:text-base px-2 py-1 sm:px-4 sm:py-2">Fee</TableCell>
                  <TableCell className="text-xs sm:text-sm md:text-base px-2 py-1 sm:px-4 sm:py-2">{facility.fee}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="text-xs sm:text-sm md:text-base px-2 py-1 sm:px-4 sm:py-2">Location</TableCell>
                  <TableCell className="text-xs sm:text-sm md:text-base px-2 py-1 sm:px-4 sm:py-2 break-words">{facility.location_id}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </div>
      </Tooltip>
    </div>
  
</CustomModal>



      <CustomModal isModal={isDeleteModalOpen} handleModal={toggleDeleteModal} size='md'>
        <div className='m-5'>
            <h2 className="text-xl font-medium">Delete Facility?</h2>
            <p className="text-gx-ink-soft mt-3">Are you sure you want to delete this facility?</p>
            <button className={`flex bg-red-600 p-2 px-5 rounded-lg text-white font-medium hover:bg-red-700 mt-5 float-right mb-5 ${buttonLoading ? "cursor-not-allowed bg-gray-400" : ""}`} onClick={deleteFacility} disabled={buttonLoading}>
              {buttonLoading ? "Deleting..." : "Delete"}
              {buttonLoading && (
                <CircularProgress size={20} className="ml-2 mt-1" sx={{ color:'#fff' }} />
              )}
            </button>
        </div>
      </CustomModal>


      {
        isPopupOpen && (
            <Popup 
             onClose={() => setIsPopupOpen(false)}
             alertType={isSuccessAlert ? 'success' : isFaliureAlert ? 'failure' : ''}
             message={isSuccessAlert ? successMessage : isFaliureAlert ? failureMessage : ''}
             />
        )
      }
    </>
  )
}

export default Facilities